<template>
    <div
        class="cp input-group"
        v-if="inputModelType === 'date' || inputModelType === 'month' || inputModelType === 'datetime-local' || inputModelType === 'time'"
    >
        <cpDatePicker
            :label="obj.caption? '最早'+ obj.caption: '最早'"
            :type="inputModelType"
            v-model="searchCondition.value.start"
        ></cpDatePicker>
        <cpDatePicker
            :label="obj.caption? '最晚'+ obj.caption: '最晚'"
            :type="inputModelType"
            v-model="searchCondition.value.end"
        ></cpDatePicker>
    </div>
    <div
        class="cp input-group"
        v-else-if="inputModelType === 'autocomplete'"
    >
        <cpAutocomplete
            :label="obj.caption"
            :options="optionsFilter.map(item => item.value)"
            v-model="searchCondition.value"
        ></cpAutocomplete>
    </div>
    <div
        class="cp input-group"
        v-else-if="inputModelType === 'number'"
    >
        <div
            class="cp input"
            :class="inputModelType"
        >
            <label :for="obj.prop +'-min'" v-html="obj.caption? '最小'+ obj.caption: '最少'"></label>
            <input
                ref="input"
                type="number"
                :id="obj.prop +'-min'"
                v-model="searchCondition.value.min"
                :placeholder="placeholder"
            >
        </div>
        <div
            class="cp input"
            :class="inputModelType"
        >
            <label :for="obj.prop +'-max'" v-html="obj.caption? '最大'+ obj.caption: '最多'"></label>
            <input
                ref="input"
                type="number"
                :id="obj.prop +'-max'"
                v-model="searchCondition.value.max"
                :placeholder="placeholder"
            >
        </div>
    </div>
    <div
        class="cp input-group"
        v-else-if="inputModelType === 'tab'"
    >
        <cpBtn
            v-for="item in optionsFilter"
            :key="item.value"
            :themes="searchCondition.value.includes(item.value)? 'is-expert': ''"
            :text="item.value"
            @click="setTabValue(obj.prop, item.value)"
        >
            <cpLabel
                :themes="searchCondition.value.includes(item.value)? 'minor': 'expert'"
                :text="item.length"
            ></cpLabel>
        </cpBtn>
    </div>
    <div
        v-else-if="inputModelType === 'combobox'"
        class="cp input combobox"
        :style="style"
    >
        <label>{{ obj.caption }}</label>
        <a @click.prevent.stop="toggle()">{{ boxCaption }}</a>
        <transition name="animate">
            <ul v-if="show" class="func" @click.stop>
                <li
                    v-for="(item, index) in optionsFilter"
                    :key="item.value"
                >
                    <div class="cp input checkbox">
                        <input type="checkbox" :id="'check-'+ index +'-'+ item.value" v-model="searchCondition.value" :value="item.value">
                        <label :for="'check-'+ index +'-'+ item.value">{{ item.value }} ({{ item.length }})</label>
                    </div>
                </li>
            </ul>
        </transition>
    </div>
    <div
        v-else-if="inputModelType === 'checkbox'"
        class="cp input div is-inputBox"
    >
        <label :for="obj.prop">{{ obj.caption }}</label>
        <div class="cp input checkbox" v-if="optionsFilter.length > 0">
            <span
                v-for="(item, index) in optionsFilter"
                :key="item.value"
            >
                <input type="checkbox" :id="'check-'+ index +'-'+ item.value" v-model="searchCondition.value" :value="item.value">
                <label :for="'check-'+ index +'-'+ item.value">{{ item.value }} ({{ item.length }})</label>
            </span>
        </div>
        <div class="cp input" v-else>
            <label>無可用項目</label>
        </div>
    </div>
    <div
        v-else-if="inputModelType === 'select'"
        class="cp input select"
    >
        <label :for="obj.prop">{{ obj.caption }}</label>
        <select
            ref="input"
            :id="obj.prop"
            v-model="searchCondition.value"
            v-if="optionsFilter.length > 0"
        >
            <option value="">{{ placeholder }}</option>
            <option
                v-for="item in optionsFilter"
                :value="item.value"
                :key="item.value"
            >{{ item.value }} ({{ item.length }})</option>
        </select>
        <select v-else>
            <option value="">無可用項目</option>
        </select>
    </div>
    <div
        v-else-if="inputModelType === 'color'"
        class="cp input text"
    >
        <label :for="obj.prop">{{ obj.caption }}</label>
        <input
            ref="input"
            type="text"
            :id="obj.prop"
            v-model="searchCondition.value"
            :placeholder="placeholder"
        >
    </div>
    <div
        v-else
        class="cp input"
        :class="inputModelType || 'text'"
    >
        <label :for="obj.prop">{{ obj.caption }}</label>
        <input
            ref="input"
            :type="inputModelType"
            :id="obj.prop"
            v-model="searchCondition.value"
            :placeholder="placeholder"
        >
    </div>
</template>

<script>
    import cpDatePicker from '@/components/cpDatePicker'
    import cpAutocomplete from '@/components/cpAutocomplete'
    import cpBtn from '@/components/cpBtn'
    import cpLabel from '@/components/cpLabel'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            cpDatePicker,
            cpAutocomplete,
            cpBtn,
            cpLabel,
        },
        props: {
            obj: {
                type: Object,
                require: true
            },
            searchCondition: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let _id = this.$okaTool.getUUID();

            return {
                id: _id,
                show: false
            }
        },
        computed: {
            optionsFilter: function(){
                let $obj = this.obj,
                    $options = $obj.options || [];

                return $options.filter(item => item.length > 0 );
            },
            style: function(){

                if( this.show ) {
                    return {
                        'z-index': 5
                    }
                }else {
                    return {};
                }
            },
            boxCaption: function(){
                let $searchCondition = this.searchCondition,
                    $value = $searchCondition.value,
                    _result = this.placeholder;

                if( $value.length ) {
                    _result = $value.join(', ');
                }

                return _result;
            },
            inputModelType: function(){
                return this.obj.inputtype;
            },
            placeholder: function(){
                let _type = this.inputModelType;

                if( _type === 'color' ) {
                    return '請輸入色碼';
                }else if( _type === 'number' ) {
                    return '請輸入數字';
                }else if( _type === 'combobox' ) {
                    return '請核選項目';
                }else if( _type === 'select' ) {
                    return '無';
                }else{
                    return '請輸入文字';
                }
            }
        },
        methods: {
            ...mapMutations([
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear'
            ]),
            setTabValue: function(prop, value){
                this.$emit('sendEvent', 'setTabValue', prop,value);
            },
            toggle: function(){
                this.globalClickFuncQueueRun(this.id);
                this.show = !this.show;
            },
            hide: function(){
                this.show = false;
            }
        },
        created: function(){
            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    .cp.group {
        margin: 0;
        display: inline;
        vertical-align: middle;
    }
    
    .cp.input-group {
        display: inline;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>
